import { FC } from 'react';

import ProgressBar from 'components/_core/ProgressBar';

import { useStepperContext } from '../hooks';

// When at the beginning of the flow, show an indicator that the bar fills
// itself with every step instead of displaying an empty grey bar.
const MINIMAL_RATIO = 0.025;

const StepperProgressBar: FC = () => {
  const { currentStepIdx, nbSteps } = useStepperContext();

  const ratio = Math.max(
    MINIMAL_RATIO,
    currentStepIdx / (nbSteps <= 1 ? 1 : nbSteps - 1),
  );

  return <ProgressBar ratio={ratio} />;
};

export default StepperProgressBar;
